import templateUrl from './confirmation-employer.component.html';

export const ConfirmationEmployerComponent = {
    templateUrl,
    controller: ConfirmationEmployerController,
    controllerAs: "vm",
    bindings: {
        ownerView: "<",
        owner: "<",
        employee: "<",
        employeeProfile: "<",
        profile: "<",
        employeeBankInfo: "<",
        provinces: "<",
        application: "<",
        genderOptions: "<",
        bankInfo: "<"
    }
}

function ConfirmationEmployerController($state, utilityService, onboardingDocumentService) {
    'ngInject';
    const vm = this;

    vm.confirmationForm;
    vm.isApproved = false;
    vm.onShowApplications = onShowApplications;
    vm.onShowDirectDeposit = onShowDirectDeposit;
    vm.onApprove = onApprove;

    vm.$onInit = function () {
        utilityService.hideLoading();
    }

    function onApprove() {
        utilityService.showLoading();
        if (vm.confirmationForm && vm.confirmationForm.$invalid) {
            alert("Please check the confirmation checkbox!");
            return;
        }
        onboardingDocumentService.approveApplication(vm.application.EmployeeId).then((data) => {
            if (!data) {
                alert('Approval Failed! Please try again.');
                return;
            }
            return $state.go("application-status");
        }).then(() => {
            utilityService.hideLoading()
        }).catch((err) => {
            console.log(err);
            utilityService.hideLoading();
        });

    }

    function onShowDirectDeposit() {
        return $state.go("application-status.ownermodal.directdeposit");
    }

    function onShowApplications() {
        return $state.go("application-status");
    }
}
